export default window.unauthEmailChildSettings || {};
